/** @format */
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FudisValidators } from '@funidata/ngx-fudis';
import { TranslocoService } from '@ngneat/transloco';
import { StateService } from '@uirouter/core';
import { take, combineLatest } from 'rxjs';
import { ComponentDowngradeMappings, DowngradedComponent, StaticMembers } from 'sis-common';
import { AppErrorHandler } from '../error-handler/app-error-handler';
import { FeedbackService } from './feedback.service';

@StaticMembers<DowngradedComponent>()
@Component({
    selector: 'sis-feedback',
    templateUrl: './feedback.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class FeedbackComponent implements OnInit {
    static readonly downgrade: ComponentDowngradeMappings = {
        moduleName: 'sisComponents.feedback',
        directiveName: 'feedback',
    };

    form: FormGroup;
    control: FormControl;
    options = [
        { labelKey: 'FEEDBACK.ANSWER_5', value: 5 },
        { labelKey: 'FEEDBACK.ANSWER_4', value: 4 },
        { labelKey: 'FEEDBACK.ANSWER_3', value: 3 },
        { labelKey: 'FEEDBACK.ANSWER_2', value: 2 },
        { labelKey: 'FEEDBACK.ANSWER_1', value: 1 },
    ];

    constructor(
        private readonly feedbackService: FeedbackService,
        private readonly translocoService: TranslocoService,
        private readonly errorHandler: AppErrorHandler,
        private readonly stateService: StateService,
    ) {}

    ngOnInit() {
        this.buildForm();
    }

    buildForm() {
        combineLatest([this.translocoService.selectTranslate('SIS_COMPONENTS.COMMON_VALIDATION_ERRORS.REQUIRED')])
            .pipe(take(1))
            .subscribe(([requiredErrorMsg]) => {
                this.control = new FormControl(undefined, [FudisValidators.required(requiredErrorMsg)]);
                this.form = new FormGroup({ rating: this.control });
            });
    }

    onSubmit() {
        if (this.control.invalid) {
            return;
        }
        const value = Number(this.control.getRawValue());
        this.feedbackService
            .postAnswer(value)
            .pipe(this.errorHandler.defaultErrorHandler())
            .subscribe(() => this.stateService.go('^.feedback-thank-you'));
    }
}
